import Axios from 'axios';
import React from 'react';
import Head from 'next/head';
import { SWRConfig } from 'swr';
import NextApp from 'next/app';
import { useRouter } from 'next/router';
import { NextIntlProvider } from 'next-intl';

import { siteName, globalLocales } from '@strongio/pretrained-dashboard/settings';
import loadMessages from '@strongio/pretrained-dashboard/messages';
import { DialogProvider } from '@strongio/pretrained-dashboard/dialog';
import NotificationContainer from '@strongio/pretrained-dashboard/notification';
import { redirectForAuth, AuthProvider } from '@strongio/pretrained-dashboard/auth';
import PageLoadingIndicator from '@strongio/pretrained-dashboard/components/PageLoadingIndicator';

export default function PretrainedApp({ Component, pageProps, messages }) {
  const router = useRouter();
  const title = pageProps.title ? `${pageProps.title} | ${siteName}` : siteName;

  const redirectUrl = redirectForAuth(pageProps.noAuth, pageProps.noMfa);
  if (redirectUrl) {
    router.push(redirectUrl);
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

  return /*#__PURE__*/(
    React.createElement(SWRConfig, {
      value: {
        fetcher: (resource) => Axios.get(resource).then((r) => r.data) } }, /*#__PURE__*/


    React.createElement(Head, null, /*#__PURE__*/
    React.createElement("title", null, title)), /*#__PURE__*/

    React.createElement(PageLoadingIndicator, null), /*#__PURE__*/
    React.createElement(NextIntlProvider, { messages: { ...messages, ...pageProps.messages } }, /*#__PURE__*/
    React.createElement(AuthProvider, { noAuth: pageProps.noAuth || pageProps.noMfa }, /*#__PURE__*/
    React.createElement(NotificationContainer, null, /*#__PURE__*/
    React.createElement(DialogProvider, null, /*#__PURE__*/
    React.createElement(Component, pageProps)))))));






}

PretrainedApp.getInitialProps = async function getInitialProps(context) {
  const { locale } = context.router;

  return {
    ...(await NextApp.getInitialProps(context)),
    messages: await loadMessages(globalLocales, locale) };

};